import type { FC } from 'react';
import { useTheme } from 'styled-components';
import type { IIconsProps } from './types';
import { IconScale } from './types';

const Cashes: FC<IIconsProps> = ({
  color,
  fillcolor,
  size = IconScale.M,
}: IIconsProps) => {
  const theme = useTheme();
  if (!color) {
    color = theme.palette.primary.main;
  }
  if (!fillcolor) {
    color = theme.palette.neutral['00'];
  }
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_2040_197)">
        <path
          d="M3 19L13 19C14.1046 19 15 18.1046 15 17L15 3C15 1.89543 14.1046 1 13 1L3 1C1.89543 1 1 1.89543 1 3L1 17C1 18.1046 1.89543 19 3 19Z"
          fill={fillcolor}
          stroke={color}
          strokeWidth="2"
        />
        <path
          d="M6.5 16L9.5 16C9.77614 16 10 15.7761 10 15.5C10 14.6716 10.6716 14 11.5 14C11.7761 14 12 13.7761 12 13.5L12 6.5C12 6.22386 11.7761 6 11.5 6C10.6716 6 10 5.32843 10 4.5C10 4.22386 9.77614 4 9.5 4L6.5 4C6.22386 4 6 4.22386 6 4.5C6 5.32843 5.32843 6 4.5 6C4.22386 6 4 6.22386 4 6.5L4 13.5C4 13.7761 4.22386 14 4.5 14C5.32843 14 6 14.6716 6 15.5C6 15.7761 6.22386 16 6.5 16Z"
          stroke={color}
          strokeWidth="2"
        />
        <circle
          cx="8"
          cy="10"
          r="1"
          transform="rotate(-90 8 10)"
          fill={color}
        />
        <path
          d="M11 23L21 23C22.1046 23 23 22.1046 23 21L23 7C23 5.89543 22.1046 5 21 5L11 5C9.89543 5 9 5.89543 9 7L9 21C9 22.1046 9.89543 23 11 23Z"
          fill={fillcolor}
          stroke={color}
          strokeWidth="2"
        />
        <path
          d="M14.5 20L17.5 20C17.7761 20 18 19.7761 18 19.5C18 18.6716 18.6716 18 19.5 18C19.7761 18 20 17.7761 20 17.5L20 10.5C20 10.2239 19.7761 10 19.5 10C18.6716 10 18 9.32843 18 8.5C18 8.22386 17.7761 8 17.5 8L14.5 8C14.2239 8 14 8.22386 14 8.5C14 9.32843 13.3284 10 12.5 10C12.2239 10 12 10.2239 12 10.5L12 17.5C12 17.7761 12.2239 18 12.5 18C13.3284 18 14 18.6716 14 19.5C14 19.7761 14.2239 20 14.5 20Z"
          stroke={color}
          strokeWidth="2"
        />
        <circle
          cx="16"
          cy="14"
          r="1"
          transform="rotate(-90 16 14)"
          fill={color}
        />
      </g>
      <defs>
        <clipPath id="clip0_2040_197">
          <rect
            width="24"
            height="24"
            fill={fillcolor}
            transform="translate(0 24) rotate(-90)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default Cashes;
